"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var InputText_styles_1 = __importDefault(require("./InputText.styles"));
var FormErrorMessage_1 = __importDefault(require("../FormErrorMessage/FormErrorMessage"));
var InputText = function (_a) {
    var id = _a.id, label = _a.label, placeholder = _a.placeholder, _b = _a.type, type = _b === void 0 ? 'text' : _b, _c = _a.required, required = _c === void 0 ? false : _c, value = _a.value, error = _a.error, valueChanged = _a.valueChanged;
    return (react_1.default.createElement(InputText_styles_1.default, { errored: error && error.length > 0 },
        react_1.default.createElement("label", { htmlFor: id }, label),
        react_1.default.createElement("input", { id: id, type: type, name: id, placeholder: placeholder, required: required, defaultValue: value, onInput: function (e) {
                if (valueChanged)
                    valueChanged(id, e.currentTarget.value);
            } }),
        react_1.default.createElement(FormErrorMessage_1.default, null, error)));
};
exports.default = InputText;
